import { useSelector } from 'react-redux'
import {
  getMajorCategories,
  isLoadingCategories,
} from 'store/Categories/selectors'
import { getIsItemsLoading } from 'store/Items/selector'
import { map } from 'lodash'
import Section from 'components/Section'
import ReportingCategoryItem from './ReportingCategoryItem'

import Loader from 'components/Loader'

const ReportingCategoriesList = () => {
  const reportingCategories = useSelector(getMajorCategories)
  const isCategoriesLoading = useSelector(isLoadingCategories)
  const isItemsLoading = useSelector(getIsItemsLoading)

  const isLoading = isCategoriesLoading || isItemsLoading
  return (
    <Section className="item-list">
      {isLoading ? (
        <Loader />
      ) : (
        map(reportingCategories, (reportingCategory) => (
          <ReportingCategoryItem
            name={reportingCategory.name}
            uuid={reportingCategory.uuid}
            key={reportingCategory.uuid}
          />
        ))
      )}
    </Section>
  )
}

export default ReportingCategoriesList
